import React, {useEffect, useState} from 'react';
import {Button, Header, Icon, Input, Pagination, Segment, Table} from 'semantic-ui-react';
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast} from "react-toastify";
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {ToasterConfig} from "../../../config/ToasterConfig";
import {AppMessagesFilters} from "../../../filters/app-messages-filters";
import {AppMessage} from "../../../models/appMessage";
import useAppMessagesService from "../../../services/backoffice/hooks/useAppMessagesService";

const AppMessagesList = () => {
    const [messages, setMessages] = useState<AppMessage[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState<AppMessagesFilters>()
    const [totalPages, setTotalPages] = useState<number>()
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const {getAppMessages, deleteAppMessage} = useAppMessagesService();
    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };
    useEffect(() => {
        listAppMessages();
    }, [filter]);


    async function listAppMessages() {
        setLoading(true)
        const response = (await getAppMessages(filter).finally(() => setLoading(false)));
        setTotalPages(response.totalPages);
        setMessages(response.itens);
    }


    async function deleteAppMessageFunction(message: AppMessage) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja apagar a mensagem?`);

            if (confirm) {
                if (message) {
                    await deleteAppMessage(message.id);
                    toast.success('Mensagem deletada com sucesso', ToasterConfig.success);
                    listAppMessages()
                }
                setLoading(false);
            }
        } catch (error: any) {
            toast.warn(`Falha ao deletar mensagem`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    }

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Mensagens do Aplicativo
            </Header>
            <Table.Row>
                <Table.HeaderCell>
                    {(sessionUser?.userData?.profile === 'Admin' || 'Manager') &&
                        <Button color="green"
                                onClick={() => navigate('/backoffice/app-messages/create/')}>

                            <Icon name='plus'/> Nova mensagem
                        </Button>}
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="4">
                    <Button onClick={toggleFilters} primary>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>{showFilters && (
            <Segment>
                <div style={{padding: 10}}>
                    <div>
                        <Input
                            fluid
                            icon="search"
                            type="text"
                            placeholder="Nome do Remetente"
                            value={filter?.sender ?? ''}
                            onChange={event =>
                                setFilter({...filter, sender: event.target?.value})
                            }
                        />
                    </div>
                    <br/>
                    <div>
                        <Input
                            fluid
                            icon="search"
                            type="text"
                            placeholder="Assunto"
                            value={filter?.subject ?? ''}
                            onChange={event =>
                                setFilter({...filter, subject: event.target?.value})
                            }
                        />
                    </div>
                    <br/>
                </div>
            </Segment>
        )}

            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Assunto</Table.HeaderCell>
                        <Table.HeaderCell>Mensagem</Table.HeaderCell>
                        <Table.HeaderCell>Vencimento</Table.HeaderCell>
                        <Table.HeaderCell>Data de Criação</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                {(sessionUser?.userData?.profile === 'Admin' || 'Manager') &&
                    <Table.Body>
                        {messages?.map((message) => (
                            <Table.Row key={message.id}>
                                <Table.Cell>
                                    <Button.Group>
                                        <Button color="red" onClick={() => deleteAppMessageFunction(message)}
                                                icon={'trash'}></Button>

                                    </Button.Group>
                                </Table.Cell>
                                <Table.Cell>{`${message?.subject}`}</Table.Cell>
                                <Table.Cell>{`${message?.message}`}</Table.Cell>
                                <Table.Cell>{moment(message.dueDate).format('DD/MM/YY HH:mm')}</Table.Cell>
                                <Table.Cell>{moment(message.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>

                            </Table.Row>
                        ))}
                    </Table.Body>}
            </Table>
            <Pagination totalPages={totalPages ?? 0}
                        defaultActivePage={filter?.Page ?? 1}
                        onPageChange={(e, {activePage}) => {
                            setFilter({...filter, Page: activePage as number})
                        }
                        }>
            </Pagination>
        </div>
    );
};

export default AppMessagesList;
